import React from 'react';

export const LazySampleOrder = React.lazy(() =>
  import(/* webpackChunkName: 'SampleOrder' */ '../../SampleOrder').then((module) => ({
    default: module.SampleOrder,
  })),
);
